module.exports = __webpack_public_path__ + "img/noAssCourse.a561db1a.svg";